import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import getInitLanguage from "../../utils/getInitLanguage";
import loadLocalesData from "../../utils/loadLocalesData";
const initialData = {
    language: getInitLanguage(),
    messages: {},
    isLoading: true,
    onSelectLanguage: () => () => { }
};
const DataContext = createContext(initialData);
const DataContextProvider = ({ locales, children }) => {
    const [language, setLanguage] = useState(initialData.language);
    const [messages, setMessages] = useState(initialData.messages);
    const [isLoading, setIsLoading] = useState(initialData.isLoading);
    const onSelectLanguage = useCallback((language) => () => {
        setLanguage(language);
    }, []);
    useEffect(() => {
        async function loadData() {
            try {
                const [loadedMessages] = await Promise.all(
                // @ts-ignore
                loadLocalesData(language, locales));
                if (loadedMessages && loadedMessages.default && loadedMessages.default.MainTitle) {
                    document.title = loadedMessages.default.MainTitle;
                }
                setMessages(loadedMessages.default);
                setIsLoading(false);
            }
            catch (error) {
                console.error(error);
            }
        }
        loadData();
    }, [language]);
    const value = {
        language,
        messages,
        isLoading,
        onSelectLanguage
    };
    return (React.createElement(DataContext.Provider, { value: value }, children));
};
const useData = () => useContext(DataContext);
export { DataContextProvider, useData };
